import { useEffect, useState } from 'react';
import { EmmShopOrder, emmShopOrderListGetApi } from '../../api/apiConfig';
import useFetch from '../../api/useFetch';
import styled from 'styled-components';
import {
  formatEightDigitStringToSixDigitDot,
  getYearMonthDateFromDate,
} from '../../function/replaceString';

export const EmmShopChangePreview = () => {
  const [data, setData] = useState<EmmShopOrder[]>([]);
  const { fetch: fetchEmmShopOrderListGetApi } = useFetch({
    fetchFunction: emmShopOrderListGetApi,
    onSuccess: (data: EmmShopOrder[]) => {
      setData(data);
    },
  });

  useEffect(() => {
    fetchEmmShopOrderListGetApi();
  }, []);

  return (
    <Container>
      {data.length > 0 ? (
        <>
          <Row>
            <div className='des'>주문정보</div>
            <div className='count'>주문일자</div>
          </Row>

          <BodyContainer>
            {data
              .sort(
                (a, b) =>
                  Number(
                    getYearMonthDateFromDate(new Date(a.orderTime)).dateString
                  ) -
                  Number(
                    getYearMonthDateFromDate(new Date(b.orderTime)).dateString
                  )
              )
              .map((order) => (
                <>
                  <BodyRow>
                    <div className='des'>
                      {order.products.length > 1
                        ? `${order.products[0].productName}외 1건`
                        : order.products[0].productName}
                    </div>
                    <div className='count'>
                      {formatEightDigitStringToSixDigitDot(
                        getYearMonthDateFromDate(new Date(order.orderTime))
                          .dateString
                      )}
                    </div>
                  </BodyRow>
                </>
              ))}
          </BodyContainer>
        </>
      ) : (
        <StyledH4>변경사항이 없습니다</StyledH4>
      )}
    </Container>
  );
};

const StyledH4 = styled.h4`
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 29px;
  font-weight: 600;
  font-size: 12px;
  margin-top: 7px;

  .des {
    flex: 1 0 50%;
    text-align: start;
    padding-left: 15px;
    overflow: hidden; /* 넘치는 부분 숨김 */
    text-overflow: ellipsis; /* 가려지는 부분 ... 처리 */
    white-space: nowrap; /* 줄 넘김 금지 */
  }
  .count {
    flex: 0 0 18%;
    text-align: center;
  }
`;

const BodyContainer = styled.div`
  height: 210px;
  /* background-color: #f0f0f0; */
  border-top: 1px solid #cccccc7d;
  border-bottom: 1px solid #cccccc7d;
  margin-top: 7px;
  overflow-y: scroll;
`;

const BodyRow = styled(Row)`
  border-bottom: 1px solid #cccccc7d;
  margin-top: 0px;
  font-weight: 500;
`;
